mutation PayCycleApprovalRevoke($input: PayCycleApprovalRevokeInput!) {
  payCycleApprovalRevoke(input: $input) {
    revokedApprovalEntity
  }
}
